export default {"src":"/_next/static/media/tamda-wing.82a88872.svg","height":48,"width":133,"blurWidth":0,"blurHeight":0};